// Polyfill for forEach on Nodelist in IE.
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

jQuery(document).ready(function ($) {
	/* Init the menu ASAP */
	const mobileMenuInit = function () {
		let menuToggleBar = document.querySelector('.m-main_nav__toggle');

		if (menuToggleBar) {
			if (menuToggleBar.offsetHeight > 0) {
				let menuButton = menuToggleBar.querySelector(
					'.a-main_nav__toggle__button'
				);
				let menuDrawer = document.querySelector('.m-main_nav__links_list');
				let menuClose = document.querySelector(
					'.a-main_nav__toggle__close-button'
				);
				const toggleMenu = (drawer) => {
					drawer.classList.toggle('open');
				};
				menuButton.addEventListener('click', (e) => {
					toggleMenu(menuDrawer);
				});
				menuClose.addEventListener('click', (e) => {
					toggleMenu(menuDrawer);
				});

				/**
				 * Mobile menu functionality
				 */
				let firstLevelParents = menuDrawer.querySelectorAll(
					'.a-main_nav__link--parent'
				);
				firstLevelParents.forEach((parent) => {
					let secondLevelLists = parent.querySelectorAll(
						'.m-main_nav__links_list__child_list'
					);
					let titles = parent.querySelectorAll('.a-main_nav__title');

					titles.forEach((title) => {
						let siblings = parent.parentNode.children;

						title.addEventListener('click', function (e) {
							e.preventDefault();
							console.log(e);
							for (let sibling of siblings) {
								if (sibling !== parent) {
									let siblingLists = sibling.querySelectorAll(
										'.m-main_nav__links_list__child_list'
									);
									siblingLists.forEach((list) => {
										if (list.classList.contains('open')) {
											list.classList.remove('open');
										}
									});
								}
							}
							if (!parent.classList.contains('focus')) {
								parent.classList.contains('open')
									? parent.classList.remove('open')
									: parent.classList.add('open');
							}
							title.nextElementSibling.classList.toggle('open');
							parent.parentNode.classList.toggle('is-open');
						});
					});
					secondLevelLists.forEach((list) => {
						let childLists = list.querySelectorAll('.no-link');
						for (let child of childLists) {
							child.addEventListener('click', (e) => {
								child.classList.toggle('open');
								let subList = child.querySelector(
									'.m-main_nav__links_list__child_list--sublist'
								);
								subList.classList.toggle('open');
							});
						}
					});
				});
			}
		}
		console.log('mobileMenuInit');
	};

	mobileMenuInit();

	window.addEventListener('resize', function (e) {
		if (window.innerWidth < 980) {
			mobileMenuInit();
		}
	});

	//Keyboard accessibility for Menu
	const menuItems = document.querySelectorAll('.a-main_nav__link--parent');
	menuItems.forEach((parentItem) => {
		parentItem.querySelector('a').addEventListener('focus', function (e) {
			console.log(e);
			if (!this.parentNode.classList.contains('open')) {
				this.parentNode.classList.add('open', 'focus');
				this.setAttribute('aria-expanded', 'true');
			} else {
				this.parentNode.classList.remove('open');
				this.setAttribute('aria-expanded', 'false');
			}

			let siblings = [];
			let sibling = this.parentNode.parentNode.firstChild;

			while (sibling) {
				if (sibling.nodeType === 1 && sibling !== this.parentNode) {
					siblings.push(sibling);
				}
				sibling = sibling.nextSibling;
			}

			siblings.forEach((sibling) => {
				if (sibling.classList.contains('open')) {
					sibling.classList.remove('open');
				}
			});

			e.preventDefault();
			return false;
		});
		let sublistItems = parentItem.querySelectorAll('.a-main_nav__link--child');
		let lastItem = sublistItems.length - 1;
		sublistItems[lastItem]
			.querySelector('a')
			.addEventListener('blur', function (e) {
				if (parentItem.classList.contains('open')) {
					parentItem.classList.remove('open');
				}
			});
	});
  // language_switch
	if (window.location.hostname == 'es.factsaboutbpa.org') {
		jQuery('.m-language-selector__current').text('ESPAÑOL ▾');
		jQuery('.m-language-selector__options li a').text('ENGLISH');
		jQuery('.m-language-selector__options li a').attr("href", "//www.factsaboutbpa.org");
	} else {

		jQuery('.m-language-selector__current').text('ENGLISH ▾');
		jQuery('.m-language-selector__options li a').text('ESPAÑOL');
		jQuery('.m-language-selector__options li a').attr("href", "//es.factsaboutbpa.org");
  }

	//search modal
	$('.a-main_nav__search__button').click(function () {
		$('.m-main_nav__search--modal').addClass('is-open');
		var oset = $('.o-header__logo .site_logo').height();
		$('.m-main_nav__search--modal').css('top', oset);
	});
	$('.a-main_nav__search__close-button').click(function () {
		$('.m-main_nav__search--modal').removeClass('is-open');
	});
	$('.a-main_nav__back').click(function () {
		$('.m-main_nav__links_list').removeClass('is-open');
		$('.menu-item').removeClass('open');
		$('.m-main_nav__links_list__child_list').removeClass('open');
	});
	$('.a-main_nav__toggle__close-button').click(function () {
		$('.m-main_nav__links_list').removeClass('is-open');
		$('.menu-item').removeClass('open');
		$('.m-main_nav__links_list__child_list').removeClass('open');
	});
	$('.is-open li.open > a').click(function () {
		alert('clicked');
	});
	/* End Menu Scripts */

	/* ------------------ GET THE COOKIE ------------------ */
	function getCookie(c_name) {
		//console.log('Im getting the cookie information for:' + c_name);
		var c_value = document.cookie;
		var c_start = c_value.indexOf(' ' + c_name + '=');
		if (c_start == -1) {
			c_start = c_value.indexOf(c_name + '=');
		}
		if (c_start == -1) {
			c_value = null;
		} else {
			c_start = c_value.indexOf('=', c_start) + 1;
			var c_end = c_value.indexOf(';', c_start);
			if (c_end == -1) {
				c_end = c_value.length;
			}
			c_value = unescape(c_value.substring(c_start, c_end));
		}
		return c_value;
	}

	function setCookie(c_name, value, exdays) {
		//console.log('Im Setting up a cookie!');
		var path = '/';
		var exdate = new Date();
		exdate.setDate(exdate.getDate() + exdays);
		var c_value =
			escape(value) +
			(exdays == null ? '' : '; expires=' + exdate.toUTCString());
		document.cookie = c_name + '=' + c_value + ';path=' + path + ';';
	}

	// Function after click close button
	function close_pop() {
		$('.m-cta').fadeOut();
		setCookie('signupclose', true, 30); //  days

		setTimeout(function () {
			$('.m-cta').removeClass('js-show');
		}, 1000);

		return false;
	}

	// Function after mail sent successfully
	function mail_sent() {
		// setCookie('signupdone', true, 3650); // Infinito

		$('.m-cta .wpcf7-form .m-cta__content').slideUp();

		// setTimeout(function () {
		//   $('.m-cta').fadeOut();
		//   $('.m-cta').removeClass('js-show');
		// }, 5000);

		return false;
	}

	// Run Function to display the modal
	$(document).ready(function () {
		// displaySignupModal(); // disabled
	});

	// Handles search_form slideOut
	$('body.search .navbar-top .a-input__search').attr( 'value', '' );

	$('.navbar-top .m-search__form input[type=submit]').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		if ($('.navbar-top .m-search__form .a-input__search').val().length !== 0) {
			$('#searchform').submit();
		} else {
			$('.navbar-top .m-search__form')
				.toggleClass('is-expanded')
				.toggleClass('is-collapsed');

			if (!$('.navbar-top .m-search__form').hasClass('is-expanded')) {
				$(document).blur();
			} else {
				$('.navbar-top .m-search__form .a-input__search').delay(500).focus();
			}
		}
	});

	// Handles displaying the eye modal form.
	var displaySignupModal = function () {
		if (!getCookie('signupclose') && !getCookie('signupdone')) {
			$('.m-cta').addClass('js-show');
		} else {
			$('.m-cta').removeClass('js-show');
		}
	};

	// Click close button
	$('.m-cta .m-cta__close').click(function () {
		close_pop();
	});

	// Fires when an Ajax form submission has completed successfully, and mail has been sent.
	jQuery(document).ajaxComplete(function () {
		if (jQuery('.m-cta .wpcf7-mail-sent-ok').length) {
			mail_sent();
		}

		if (jQuery('.m-cta .wpcf7-validation-errors').length) {
			// mail_sent(); // for test
		}
	});
}); // End jQuery
